import React from "react";
import PropTypes from "prop-types";
import SovosFlatButton from 's1-ui/sovos-flat-button/SovosFlatButton';
import Dialog from 'material-ui/Dialog';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";
import LinearProgress from "material-ui/LinearProgress";
import SovosPaginationFooter from "s1-ui/sovos-pagination-footer";
import "./reportsGrid.scss";
import { gridHeaderColorGray } from "theme/mainColors";
import ContextualGridMenuOptions from "../../contextualGridMenuOptions/ContextualGridMenuOptions";

const headerLabelStyle = {
  color: gridHeaderColorGray,
  fontWeight: 400,
  fontSize: 15,
  paddingBottom: 0
};

class ReportsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.reportGridColumns = [
      {
        title: "Period",
        dataKey: "period",
        width: 150
      },
      {
        title: "Report",
        dataKey: "reportName",
        width: 150
      },
      {
        title: "Generated by",
        dataKey: "createdBy",
        width: 150
      },
      {
        title: "Generated on",
        dataKey: "creationDate",
        width: 150
      },
      {
        title: "",
        width: 40,
        dataKey: "moreOptions"
      }
    ];
    this.state = {
      hoveredRow: -1,
      itemsPerPage: 10,
      page: 0,
      deleteReportModalOpen: false,
      reportIdToDelete: -1,
      fileDownloadID: null,
      fileDownloadName: ''
    };
  }

  handleRowHover = hoveredRow => this.setState({ hoveredRow });

  handleCellClick = rowID =>
    this.props.onReportSelect(
      this.props.reportsListGridData[rowID]
    );

  getStartItem = () =>
    this.props.totalItems ? this.state.itemsPerPage * this.state.page + 1 : 0;

  calculateEndItem = () => {
    const maximumItemsOnPage = this.state.itemsPerPage * (this.state.page + 1);
    if (maximumItemsOnPage > this.props.totalItems) {
      return this.props.totalItems;
    }
    return maximumItemsOnPage;
  };

  handlePrevPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if (oldState.page > 0) {
        this.props.onPageChange(oldState.page - 1, oldState.itemsPerPage);
        return {
          page: oldState.page - 1
        };
      } else {
        return {};
      }
    });
  };

  handleDeleteReportClick = reportIdToDelete => {
    this.setState({ deleteReportModalOpen: true, reportIdToDelete});
  };

  handleCloseDeleteReport = () => {
    this.setState({ deleteReportModalOpen: false, reportIdToDelete: -1});
  };

  handleDeleteReport = () => {
    this.props.onDeleteReport(this.state.reportIdToDelete);
    this.handleCloseDeleteReport();
  };

  handleNextPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if ((oldState.page + 1) * oldState.itemsPerPage < this.props.totalItems) {
        this.props.onPageChange(oldState.page + 1, oldState.itemsPerPage);
        return {
          page: oldState.page + 1
        };
      } else {
        return {};
      }
    });
  };

  handleDownloadReport = file => {
    this.setState({ fileDownloadID: file.id, fileDownloadName: file.name });
    this.props.filesActions.downloadReport(file);
  } ;

  handlePerPageChanged = ev => {
    const itemsPerPage = ev.target.value;
    this.setState({ page: 0, itemsPerPage });
    this.props.onPageChange(0, itemsPerPage);
  };

  getReportName = report =>  report.period.substring(0,8).concat('_').concat(report.reportName).concat('.').concat(report.fileExtension);

  render() {
    const {
      reportsListGridData,
      totalItems,
      fetchingReports,
      showPagination,
      displayCheckbox,
      backgroundColor
    } = this.props;
    return (
      <div className="reports-grid__main-container">
        {fetchingReports && (
          <div className="reports-grid__over-layer">
            <LinearProgress mode="indeterminate" />
          </div>
        )}
        <div
          className={ `reports-grid__table-container${
            fetchingReports ? " blur-content" : ""
          }` }
        >
          {reportsListGridData.length > 0 && (
            <Table
              key="ReportsGrid"
              fixedHeader={ true }
              onRowHover={ this.handleRowHover }
              onRowHoverExit={ this.handleRowHoverExit }
              onCellClick={ this.handleCellClick }
              multiSelectable={ true }
              className="reports-grid"
              style={ {  backgroundColor: backgroundColor } }
            >
              <TableHeader
                displaySelectAll={ false }
                enableSelectAll={ false }
                adjustForCheckbox={ displayCheckbox }
                style={ { border: "none" } }
              >
                <TableRow
                  style={ { border: "none", backgroundColor: backgroundColor } }
                >
                  {this.reportGridColumns.map(
                    ({ dataKey, width, title, disabled }) =>
                      !disabled && (
                        <TableHeaderColumn
                          key={ dataKey }
                          style={ {
                            width: width || "auto",
                            ...headerLabelStyle
                          } }
                        >
                          { title }
                        </TableHeaderColumn>
                      )
                  )}
                </TableRow>
              </TableHeader>
              <TableBody
                showRowHover={ true }
                displayRowCheckbox={ displayCheckbox }
                deselectOnClickaway={ false }
              >
                {reportsListGridData.map((report, index) => (
                  <TableRow
                    id={ `import-org-grid-row-${ index}` }
                    key={ index }
                    hovered={ report.disabled }
                    hoverable={ report.disabled }
                    selectable={ report.disabled }
                    selected={ report.selected }
                    className={ `reports-grid__table-row ${
                      report.disabled
                        ? " reports-grid__table-row_not-selectable"
                        : ""
                    }` }
                  >
                    {this.reportGridColumns.map(
                      ({ dataKey, width, disabled }) =>
                        !disabled && (
                          <TableRowColumn
                            key={ dataKey }
                            style={ {
                              width: width || "auto",
                              textOverflow: `${
                                dataKey !== "moreOptions" ? "ellipsis" : "unset"
                              }`
                            } }
                          >
                            {dataKey !== "moreOptions"
                              ? report[dataKey]
                              : this.state.hoveredRow === index && this.props.showMoreActionsIcon && (
                                <ContextualGridMenuOptions
                                  elementId={ report.id }
                                  editDisabled={ true }
                                  deleteDisabled={ false }
                                  downloadDisabled={ false }
                                  onDelete={ this.handleDeleteReportClick }
                                  onDownload={ () => this.handleDownloadReport({ id: report.fileUuid, name: this.getReportName(report) }) }
                                />
                              )}
                          </TableRowColumn>
                        )
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
          {reportsListGridData.length > 0 && showPagination && (
            <SovosPaginationFooter
              key="ReportsPaginationFooter"
              endItem={ this.calculateEndItem() }
              itemsPerPage={ this.state.itemsPerPage }
              startItem={ this.getStartItem() }
              totalItems={ totalItems }
              onPrevClicked={ this.handlePrevPage }
              onNextClicked={ this.handleNextPage }
              onPerPageChanged={ this.handlePerPageChanged }
              itemsPerPageOptions={ [10, 25, 50] }
            />
          )}
          
          <Dialog
            actions={ [
              <SovosFlatButton
                key="close-delete"
                color="secondary"
                onClick={ this.handleCloseDeleteReport }
              >
                No
              </SovosFlatButton>,
              <SovosFlatButton
                key="submit-delete"
                onClick={ this.handleDeleteReport }
              >
                Yes
              </SovosFlatButton>
            ] }
            modal={ true }
            open={ this.state.deleteReportModalOpen }
          >
            Are you sure you want to delete this report?
          </Dialog>
        </div>
      </div>
    );
  }
}

ReportsGrid.propTypes = { 
  totalItems: PropTypes.number,
  onRowRemove: PropTypes.func,
  reportsListGridData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onReportSelect: PropTypes.func,
  onPageChange: PropTypes.func,
  onDeleteReport: PropTypes.func,
  fetchingReports: PropTypes.bool,
  showPagination: PropTypes.bool,
  displayCheckbox: PropTypes.bool,
  showRemoveIcon: PropTypes.bool,
  showMoreActionsIcon: PropTypes.bool,
  onEditReport: PropTypes.func,
  backgroundColor: PropTypes.string,
  filesActions: PropTypes.shape({
    downloadReport: PropTypes.func
  }).isRequired
};

ReportsGrid.defaultProps = {
  fetchingReports: false,
  onReportSelect: () => null,
  totalItems: 0,
  onDeleteReport: () => null,
  onPageChange: () => null,
  showPagination: false,
  displayCheckbox: false,
  onRowRemove: () => null,
  showRemoveIcon: false,
  showMoreActionsIcon: false,
  backgroundColor: "#fff"
};

export default ReportsGrid;



// WEBPACK FOOTER //
// ./src/shared/components/reportGrid/ReportsGrid.js